import React, { Component } from "react";
import { MDBBtn, MDBModalBody, MDBModalHeader, MDBRow, MDBCol, MDBInput, MDBIcon, MDBTooltip } from "mdbreact";
import { withTranslation } from "react-i18next";

class ModifyRuckusR1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: props.controller?.ControllerName || "",
            url: props.controller?.URL || "",
            tenantId: props.controller?.TenantID || "",
            apiClientId: props.controller?.APIClientID || "",
            apiClientSecret: "",
            enableSync: props.controller?.enableSync || true,
            showPasswordField: false,
        };
    }

    submitModifyRuckusR1 = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";

        if (
            this.state.controllerName !== undefined &&
            this.state.controllerName !== "" &&
            this.state.url !== undefined &&
            this.state.url !== "" &&
            this.state.tenantId !== undefined &&
            this.state.tenantId !== "" &&
            this.state.apiClientId !== undefined &&
            this.state.apiClientId !== ""
        ) {
            // Only include apiClientSecret if it's been changed
            const data = {
                controllerName: this.state.controllerName,
                url: this.state.url,
                tenantId: this.state.tenantId,
                apiClientId: this.state.apiClientId,
                enableSync: this.state.enableSync,
                controllerID: this.props.controller?.ControllerID, // Include controller ID for identification
            };

            // Only include secret if user entered a new one
            if (this.state.apiClientSecret && this.state.apiClientSecret !== "") {
                data.apiClientSecret = this.state.apiClientSecret;
            }

            this.props.submitModifyRuckusR1(
                this.props.controller?.TenantID, // Original TenantID as identifier
                data.controllerName,
                data.url,
                data.tenantId,
                data.apiClientId,
                data.apiClientSecret,
                data.enableSync,
                data.controllerID
            );
        }
    };

    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    toggleEnableSync = () => {
        this.setState({ enableSync: !this.state.enableSync });
    };

    togglePasswordField = () => {
        this.setState({ showPasswordField: !this.state.showPasswordField });
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <MDBModalHeader toggle={this.props.toggleModifyRuckusR1}>
                    <h4>Modify Ruckus R1 Controller</h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitModifyRuckusR1}
                        noValidate
                    >
                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="controllerName"
                                    className="black-text"
                                >
                                    Controller Name *
                                </label>
                                <input
                                    required
                                    id="controllerName"
                                    name="controllerName"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.controllerName}
                                    placeholder="Enter controller name"
                                />
                                <div className="invalid-feedback">
                                    Please provide a controller name.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="url"
                                    className="black-text"
                                >
                                    URL *
                                </label>
                                <input
                                    required
                                    id="url"
                                    name="url"
                                    type="url"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.url}
                                    placeholder="https://api.ruckus.cloud"
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid URL.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="tenantId"
                                    className="black-text"
                                >
                                    Tenant ID *
                                </label>
                                <input
                                    required
                                    id="tenantId"
                                    name="tenantId"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.tenantId}
                                    placeholder="Enter tenant ID"
                                />
                                <div className="invalid-feedback">
                                    Please provide a tenant ID.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="apiClientId"
                                    className="black-text"
                                >
                                    API Client ID *
                                </label>
                                <input
                                    required
                                    id="apiClientId"
                                    name="apiClientId"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.apiClientId}
                                    placeholder="Enter API client ID"
                                />
                                <div className="invalid-feedback">
                                    Please provide an API client ID.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <MDBInput
                                    label="Update API Client Secret"
                                    type="checkbox"
                                    id="showPasswordField"
                                    name="showPasswordField"
                                    onChange={this.togglePasswordField}
                                    checked={this.state.showPasswordField}
                                />
                            </MDBCol>
                        </MDBRow>

                        {this.state.showPasswordField && (
                            <MDBRow>
                                <MDBCol col="12" sm="12" lg="12">
                                    <label
                                        htmlFor="apiClientSecret"
                                        className="black-text"
                                    >
                                        New API Client Secret
                                    </label>
                                    <input
                                        id="apiClientSecret"
                                        name="apiClientSecret"
                                        type="password"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.apiClientSecret}
                                        placeholder="Enter new API client secret"
                                    />
                                    <small className="form-text text-muted">
                                        Leave blank to keep existing secret
                                    </small>
                                </MDBCol>
                            </MDBRow>
                        )}

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <MDBInput
                                    label="Enable Sync"
                                    type="checkbox"
                                    id="enableSync"
                                    name="enableSync"
                                    onChange={this.toggleEnableSync}
                                    checked={this.state.enableSync}
                                >
                                <MDBTooltip material placement="left" className="rightTooltip" style={{ display: "block" }}>
                                    <MDBIcon far icon="question-circle" />
                                    <span>When enabled, any venues linked to this R1 will begin syncing Subscriber PSKs</span>
                                </MDBTooltip>
                                </MDBInput>
                            </MDBCol>
                        </MDBRow>

                        <div className="alert alert-info" role="alert" style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <MDBIcon icon="info-circle" className="mr-2" />
                            When you save your R1 connector, your SSIDs will automatically sync as Keypools within VAULT.
                        </div>

                        <div className="text-right submitButton">
                            <MDBBtn color="danger" type="submit">
                                {this.props.loading_ruckus === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    "Update Controller"
                                )}
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.props.toggleModifyRuckusR1}
                            >
                                Close
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}

export default withTranslation()(ModifyRuckusR1);
